import * as React from "react";
import type { SVGProps } from "react";
const SvgHalfscreenOnIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    className="halfscreen_on_icon_svg__icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="currentColor"
      d="m609.835 353.835 183.168-183.168h-96.128a42.667 42.667 0 1 1 0-85.334H896A42.667 42.667 0 0 1 938.667 128v199.125a42.667 42.667 0 1 1-85.334 0v-96.128L670.165 414.165a42.667 42.667 0 0 1-60.33-60.33zm-195.67 256a42.667 42.667 0 0 0-60.33 0l-183.04 183.04v-96.128a42.667 42.667 0 1 0-85.334 0v195.797a42.581 42.581 0 0 0 46.038 45.995h195.754a42.667 42.667 0 1 0 0-85.334h-96.085l183.04-183.04a42.667 42.667 0 0 0 0-60.33z"
    />
  </svg>
);
export default SvgHalfscreenOnIcon;
